/**
 * @generated SignedSource<<aebc64cf89a74d025f04ec5acc6d5e29>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentInstallments_charge$data = {
  readonly paymentMethods: ReadonlyArray<{
    readonly method?: string;
    readonly subscription?: {
      readonly installments: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly " $fragmentSpreads": FragmentRefs<"PaymentInstallmentRow_paymentSubscriptionInstallment">;
          } | null | undefined;
        } | null | undefined>;
      };
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly subscription: {
    readonly installments: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly " $fragmentSpreads": FragmentRefs<"PaymentInstallmentRow_paymentSubscriptionInstallment">;
        } | null | undefined;
      } | null | undefined>;
    };
  } | null | undefined;
  readonly " $fragmentType": "PaymentInstallments_charge";
};
export type PaymentInstallments_charge$key = {
  readonly " $data"?: PaymentInstallments_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentInstallments_charge">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": "installments",
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 12
      }
    ],
    "concreteType": "PaymentSubscriptionInstallmentConnection",
    "kind": "LinkedField",
    "name": "paymentSubscriptionInstallments",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PaymentSubscriptionInstallmentEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PaymentSubscriptionInstallment",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "PaymentInstallmentRow_paymentSubscriptionInstallment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": "paymentSubscriptionInstallments(first:12)"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentInstallments_charge",
  "selections": [
    {
      "alias": "subscription",
      "args": null,
      "concreteType": "PaymentSubscription",
      "kind": "LinkedField",
      "name": "paymentSubscription",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "paymentMethods",
      "plural": true,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "method",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PaymentSubscription",
              "kind": "LinkedField",
              "name": "subscription",
              "plural": false,
              "selections": (v0/*: any*/),
              "storageKey": null
            }
          ],
          "type": "PaymentMethodInstallments",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Charge",
  "abstractKey": null
};
})();

(node as any).hash = "64571bba43645f68e9f3813e4bd4fd51";

export default node;
